import script from "./Paginator.vue?vue&type=script&setup=true&lang=ts"
export * from "./Paginator.vue?vue&type=script&setup=true&lang=ts"

import "./Paginator.vue?vue&type=style&index=0&id=6f26642c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f26642c"]])

export default __exports__